import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { CourseUnit, Media } from '~/payload-types';
import CarouselBlock from './CarouselBlock';
import EmbedBlock from './EmbedBlock';
import KalturaBlock from './KalturaBlock';
import KlickerPracticeQuizBlock from './KlickerPracticeQuizBlock';
import ObjectiveBlock from './ObjectiveBlock';
import OlatLinkButton from './OlatLinkButton';
import PdfBlock from './PdfBlock';
import TextBlock from './TextBlock';
function BlockContent(t0) {
  const $ = _c(54);
  const {
    block,
    repositoryEntry,
    locale
  } = t0;
  const t = useTranslations();
  if (block.blockType === "kaltura") {
    let t1;
    if ($[0] !== block.attachments) {
      t1 = block.attachments as Media[] ?? [];
      $[0] = block.attachments;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== block.aspectRatio || $[3] !== block.description || $[4] !== block.title || $[5] !== block.videoId || $[6] !== t1) {
      t2 = <KalturaBlock videoId={block.videoId} attachments={t1} title={block.title} aspectRatio={block.aspectRatio} description={block.description} />;
      $[2] = block.aspectRatio;
      $[3] = block.description;
      $[4] = block.title;
      $[5] = block.videoId;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  if (block.blockType === "embed") {
    let t1;
    if ($[8] !== block.aspectRatio || $[9] !== block.description || $[10] !== block.title || $[11] !== block.url) {
      t1 = <EmbedBlock title={block.title} description={block.description} embedUrl={block.url} aspectRatio={block.aspectRatio} />;
      $[8] = block.aspectRatio;
      $[9] = block.description;
      $[10] = block.title;
      $[11] = block.url;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    return t1;
  }
  if (block.blockType === "klicker") {
    let t1;
    if ($[13] !== block.klickerCourseId || $[14] !== block.klickerPracticeQuizId || $[15] !== block.title || $[16] !== locale) {
      t1 = <KlickerPracticeQuizBlock title={block.title} klickerCourseId={block.klickerCourseId} klickerPracticeQuizId={block.klickerPracticeQuizId} locale={locale} />;
      $[13] = block.klickerCourseId;
      $[14] = block.klickerPracticeQuizId;
      $[15] = block.title;
      $[16] = locale;
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    return t1;
  }
  if (block.blockType === "pdf") {
    let t1;
    if ($[18] !== block.readingEnd || $[19] !== block.readingStart || $[20] !== block.title || $[21] !== t) {
      t1 = block.readingStart && block.readingEnd ? t("unit.pdfBlockTitle", {
        title: block.title,
        start: block.readingStart,
        end: block.readingEnd
      }) : block.title;
      $[18] = block.readingEnd;
      $[19] = block.readingStart;
      $[20] = block.title;
      $[21] = t;
      $[22] = t1;
    } else {
      t1 = $[22];
    }
    const title = t1;
    const t2 = block.file as Media;
    const t3 = block.page ?? undefined;
    let t4;
    if ($[23] !== block.description || $[24] !== t2 || $[25] !== t3 || $[26] !== title) {
      t4 = <PdfBlock title={title} description={block.description} media={t2} page={t3} />;
      $[23] = block.description;
      $[24] = t2;
      $[25] = t3;
      $[26] = title;
      $[27] = t4;
    } else {
      t4 = $[27];
    }
    return t4;
  }
  if (block.blockType === "text") {
    let t1;
    if ($[28] !== block.attachments) {
      t1 = block.attachments as Media[] ?? [];
      $[28] = block.attachments;
      $[29] = t1;
    } else {
      t1 = $[29];
    }
    let t2;
    if ($[30] !== block.content || $[31] !== t1) {
      t2 = <TextBlock content={block.content} attachments={t1} />;
      $[30] = block.content;
      $[31] = t1;
      $[32] = t2;
    } else {
      t2 = $[32];
    }
    return t2;
  }
  if (block.blockType === "objective") {
    let t1;
    if ($[33] !== block.learningObjectives) {
      t1 = block.learningObjectives ?? [];
      $[33] = block.learningObjectives;
      $[34] = t1;
    } else {
      t1 = $[34];
    }
    let t2;
    if ($[35] !== block.keywords) {
      t2 = block.keywords ?? [];
      $[35] = block.keywords;
      $[36] = t2;
    } else {
      t2 = $[36];
    }
    let t3;
    if ($[37] !== t1 || $[38] !== t2) {
      t3 = <ObjectiveBlock learningObjectives={t1} keywords={t2} />;
      $[37] = t1;
      $[38] = t2;
      $[39] = t3;
    } else {
      t3 = $[39];
    }
    return t3;
  }
  if (block.blockType === "carousel") {
    let t1;
    if ($[40] !== block.description || $[41] !== block.items || $[42] !== block.title) {
      t1 = <CarouselBlock title={block.title} description={block.description} items={block.items} />;
      $[40] = block.description;
      $[41] = block.items;
      $[42] = block.title;
      $[43] = t1;
    } else {
      t1 = $[43];
    }
    return t1;
  }
  if (block.blockType === "olat-link" && repositoryEntry) {
    const t1 = block.title || block.label || "";
    let t2;
    if ($[44] !== block.icon || $[45] !== block.olatNode || $[46] !== repositoryEntry || $[47] !== t1) {
      t2 = <div className="flex justify-center"><OlatLinkButton label={t1} icon={block.icon} olatNode={block.olatNode} repositoryEntry={repositoryEntry} /></div>;
      $[44] = block.icon;
      $[45] = block.olatNode;
      $[46] = repositoryEntry;
      $[47] = t1;
      $[48] = t2;
    } else {
      t2 = $[48];
    }
    return t2;
  }
  let t1;
  if ($[49] !== block.blockType || $[50] !== t) {
    t1 = t("unit.unknownBlockType", {
      blockType: block.blockType
    });
    $[49] = block.blockType;
    $[50] = t;
    $[51] = t1;
  } else {
    t1 = $[51];
  }
  let t2;
  if ($[52] !== t1) {
    t2 = <div>{t1}</div>;
    $[52] = t1;
    $[53] = t2;
  } else {
    t2 = $[53];
  }
  return t2;
}
export default BlockContent;